import React from 'react';
import styled from 'styled-components';
import Icon from '../../common/icon/Icon';

import Typography from '../../common/typography/Typography';
const SearchBarContainer = styled.div`
  display: flex;
  align-items: center;

  border:1px solid #D9DBE9;
  border-radius: 12px;
  padding: 15px;


  margin: 0 auto;
  @media (max-width: 768px) {
    flex-direction: column; 
    align-items: flex-start;

    padding: 10px;  
  }
`;
const Div1= styled.div`
  height:20px;
  border-radius: 12px 12px 0 0;
  width:calc(100% - 12px - 4%);
  margin:auto;
  background:#EDDFFF;
`;


const Item = styled.div`
  display: flex;

  flex-direction:column;
  flex: 1;
  padding: 20px;
`;

// Divider between items
const Divider = styled.div`
  height: 40px;
  width: 1px;

  background-color: #ccc;
  @media (max-width: 768px) {
      width:100%;
      height: 1px;
  }
`;


const Label = styled.div`
  color: #6F6D7B;
  margin-bottom: 4px;
`;

const Value = styled.div`

`;
const IconTextWrapper = styled.div`
   display:flex;
   align-items:center;
   gap:10px;

`;


const SearchButton = styled.button`
  align-self:flex-end;
  background-color: #675de7;
  border: none;
  color: white;
  border-radius: 8px;
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover {
    background-color: #5749d6;
  }
`;

// Example usage
const SearchBar = () => {
    return (<>

        <Div1/>
        <Div1 style={{background:"#7174FF", width :"calc(100% - 12px - 2%)"}} />
        <SearchBarContainer>
            <Item>
                <Label><Typography size="18px" weight="500"> Location</Typography></Label>


                <IconTextWrapper>
                    <Icon src="./static/icons/location_outlined_grey.svg" style={{ marginRight: '10px' }} size="22px" />
                    <Value><Typography size="20px" weight="500" color="#464356">Algeria</Typography></Value>
                </IconTextWrapper>
            </Item>

            <Divider />

            <Item>
                <Label><Typography size="18px" weight="500"> Category</Typography></Label>

                <IconTextWrapper>
                    <Icon src="./static/icons/folders.svg" style={{ marginRight: '10px' }} size="22px" />
                    <Value><Typography size="20px" weight="500" color="#464356">Music</Typography></Value>
                </IconTextWrapper>
            </Item>

            <Divider />

            <Item>
                <Label><Typography size="18px" weight="500"> Pricing Range</Typography></Label>

                <IconTextWrapper>
                    <Icon src="./static/icons/currency_circle.svg" size="22px" />
                    <Value><Typography size="20px" weight="500" color="#464356">2000DA - 5500DA</Typography></Value>
                </IconTextWrapper>
            </Item>

            <SearchButton>
                <Icon src="./static/icons/search.svg" size="24px" />
            </SearchButton>
        </SearchBarContainer>
    </>
    );
};

export default SearchBar;
